import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchHighlighter'
})
export class SearchHighlighterPipe implements PipeTransform {
  transform(value: any, args: string, type: string): unknown {
    if (!args) return value;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = value;

    const walkNodes = (node: Node): void => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || '';
        let highlightedText;

        if (type === 'full') {
          const re = new RegExp("\\b(" + args + "\\b)", 'igm');
          highlightedText = text.replace(re, `<span class="highlighted-text">$1</span>`);
        } else {
          const re = new RegExp(args, 'igm');
          highlightedText = text.replace(re, `<span class="highlighted-text">$&</span>`);
        }

        if (highlightedText !== text) {
          const tempSpan = document.createElement('span');
          tempSpan.innerHTML = highlightedText; // Safely inject HTML
          node.parentNode?.replaceChild(tempSpan, node);
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        Array.from(node.childNodes).forEach(walkNodes);
      }
    };

    Array.from(tempDiv.childNodes).forEach(walkNodes);

    return tempDiv.innerHTML;
  }
}
